import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { Form } from '~/shared/form/form';

export const FieldDate = Form.field<Date, DateTimePickerProps<Dayjs> & { fullWidth?: boolean }>(
	({ field, slotProps, fullWidth = true, ...props }) => {
		return (
			<DateTimePicker
				label={field.label}
				value={field.value ? dayjs(field.value) : null}
				ampm={false}
				format="YYYY-MM-DD HH:mm"
				onChange={newValue => field.set(newValue as any)}
				{...props}
				slotProps={{
					...slotProps,
					actionBar: { actions: ['clear'], ...slotProps?.actionBar },
					textField: {
						fullWidth,
						error: !!field.error,
						helperText: field.error,
						...slotProps?.textField,
					},
				}}
			/>
		);
	},
);
